import { createSlice } from '@reduxjs/toolkit'

export const Accountsview = createSlice({
  name: 'accountview',
  initialState: {
    value: null,
  },
  reducers: {     
    setviewaccount: (state, action) => {
      state.value = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setviewaccount } = Accountsview.actions

export default Accountsview.reducer